import { render, staticRenderFns } from "./_base-address-edit-form.vue?vue&type=template&id=73403ccc&scoped=true"
import script from "./_base-address-edit-form.vue?vue&type=script&lang=js"
export * from "./_base-address-edit-form.vue?vue&type=script&lang=js"
import style0 from "./_base-address-edit-form.vue?vue&type=style&index=0&id=73403ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73403ccc",
  null
  
)

export default component.exports